import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';

/**
 * Mounting AuthProvider costs one GET /auth/me per document load, so only
 * routes that can have a session sit under it. App.test.tsx pins the split.
 */
export function SessionScope() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
